// extracted by mini-css-extract-plugin
export default {"button":"buttons_button__7bR4c","blueButton":"buttons_blueButton__ncyMh","blackButton":"buttons_blackButton__3GMrQ"};